module.exports = __webpack_public_path__ + "assets/images/truck-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/truck-on.png
// module id = 1529
// module chunks = 1